<template>
  <div id="tester-do-test" class="container-fluid">
    <div class="row">
      <div class="col-12">
        <h3>
          Question {{ states.seqno + 1 }}
          <small> (out of {{ testData.sequences.length }}) </small>
        </h3>
      </div>
    </div>
    <qa-detail
      v-if="
        states.test_type == 'detail' &&
          states.page == 1 &&
          states.loading == false
      "
      ref="qa-detail"
      :seqId="testData.sequences[states.seqno].id"
      :question="question"
      :refQuestion="refQuestion"
      :eventHandler="localEventHandler"
    />
    <qs-detail
      v-if="
        states.test_type == 'detail' &&
          states.page == 2 &&
          states.loading == false
      "
      ref="qs-detail"
      :seqId="testData.sequences[states.seqno].id"
      :question="question"
      :refQuestion="refQuestion"
      :eventHandler="localEventHandler"
    />
    <q-simple
      v-if="states.test_type == 'simple' && states.loading == false"
      ref="q-simple"
      :seqId="testData.sequences[states.seqno].id"
      :question="question"
      :refQuestion="refQuestion"
      :eventHandler="localEventHandler"
    />
  </div>
</template>

<script>
import api_tester from '@/api/api_tester'
// import MathJax from '@/MathJax'
import QAdetail from './QAdetail'
import QSdetail from './QSdetail'
import Qsimple from './Qsimple'
import auth from '@/app/auth'

export default {
  components: {
    'qa-detail': QAdetail,
    'qs-detail': QSdetail,
    'q-simple': Qsimple
  },

  data () {
    return {
      testid: this.$route.params.testid,
      testData: {
        sequences: [{ id: 0 }]
      },
      question: {},
      refQuestion: {},
      states: {
        test_type: 'detail',
        page: 2,
        seqno: 0,
        loading: false
      }
    }
  },
  created () {
    this.loadTest(this.testid)
  },
  updated () {
    renderMathInElement($('#tester-do-test')[0], {
      delimiters: [
        { left: '$$', right: '$$', display: true },
        { left: '$', right: '$', display: false }
      ]
    })
  },
  methods: {
    localEventHandler (name, event) {
      if (name == 'submit-success') {
        if (this.states.test_type == 'detail') {
          if (this.states.page == 1) {
            this.states.page = 2
            this.$nextTick(_ => {
              this.$refs['qs-detail'].$forceUpdate()
              // MathJax.config('mj')
            })
          } else if (this.states.page == 2) {
            this.nextQuestion()
          }
        } else if (this.states.test_type == 'simple') {
          this.nextQuestion()
        }
        auth.refresh(false)
      } else if (name == 'update-solution') {
        this.question.solution = event.solution
        this.refQuestion.solution = event.refSolution
        // this.$nextTick(_ => {
        //   MathJax.config('mj')
        // })
      }
    },
    nextQuestion () {
      this.states.loading = true
      this.$nextTick(_ => {
        if (this.states.seqno < this.testData.sequences.length - 1) {
          this.states.seqno += 1
          this.states.page = 1
          this.$nextTick(_ => {
            this.loadTest(this.testid, this.states.seqno)
          })
        } else {
          this.redirect('home')
        }
      })
    },

    updateCurrentView () {
      ;['qa-detail', 'qs-detail', 'q-simple'].map(r => {
        if (this.$refs[r]) {
          this.$refs[r].reset()
          this.$refs[r].$forceUpdate()
        }
        // MathJax.config('mj')
      })
    },
    loadTest (testid) {
      this.states.loading = true
      api_tester.get_test(testid).then(data => {
        this.testData = data
        // prettier-ignore
        if (data == null) { this.testData = {}; return; }
        // get last answered question as seqno
        this.states.seqno = this.testData.sequences
          .map(x => x.submitted)
          .findIndex(x => x == false)
        // prettier-ignore
        if (this.states.seqno == -1) {
          this.redirect('home')
        }
        var seq = this.testData.sequences[this.states.seqno]
        if (seq.type == 'detail') {
          this.states.page = seq.answer == 0 ? 1 : 2
        } else {
          this.states.page = 1
        }
        this.question = seq.question
        this.refQuestion = seq.refQuestion
        this.states.test_type = seq.type
        api_tester.add_images_to_question(this.question).then(q => {
          this.question = q
          this.states.loading = false
          this.$nextTick(_ => {
            this.updateCurrentView()
          })
        })
      })
    },
    redirect (name, params) {
      if (name == 'home') {
        this.$router.push('/tester/home')
      }
    }
  }
}
</script>

<style scoped>
#tester-do-test {
  width: 100%;
  min-width: 1024px;
}

.ans-lists {
  list-style-type: none;
  width: 100%;
}

.content-image {
  max-width: 300px;
  vertical-align: text-top;
}

.check-step {
  border-radius: 15px;
  border: solid 1px #555555;
  margin: 10px 10px;
  padding: 5px 10px;
  width: 90%;
  font-size: 20px;
}

.answer-style {
  padding: 10px 10px;
  margin: 5px 5px;
  font-size: 18px;
  border-radius: 23px;
  border: solid 1px #979797;
  display: inline-block;
}

.answer-image {
  max-width: 300px;
  vertical-align: text-top;
}

.answer-options {
  margin: 10px 5px !important;
  font-size: 18px;
}
</style>
